<template>
  <div>
    <b-table
      id="participations-table"
      striped
      hover
      borderless
      :items="participations"
      :fields="fields"
      :per-page="0"
      :no-local-sorting="true"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
      :tbody-tr-attr="rowClass"
    >
      <template v-slot:cell(paymentInfo)="row">
        <p v-if="['ISLAND_DISCOUNT', 'RF_CODE'].includes(row.item.paymentType)">
          {{ row.item.rfCode }}
        </p>
        <p v-else-if="['NONE', 'IN_PERSON'].includes(row.item.paymentType)">
          -
        </p>
        <p v-else>
          {{ `${row.item.depositNo} - ${row.item.depositComments}` }}
        </p>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("trainings.emptyTable") }}</h6>
      </template>

      <template v-slot:cell(action)="data">
        <router-link :to="{ path: `/announcement/${data.item.activity.id}` }" >
          <b-button
              size="sm"
              variant="transparent"
              v-b-tooltip.hover
              :title="$t('trainings.showAnnouncement')"
          >
            <b-icon icon="eye"></b-icon>
          </b-button>
        </router-link>
        <template v-if="data.item.canApprove">
          <template v-if="data.item.status==='UNDER_REVIEW'">
          <b-button
            size="sm"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('participations.approve')"
            @click="showApproveParticipationFn(data.item)"
          >
            <template>
              <b-icon icon="hand-thumbs-up"></b-icon>
            </template>
          </b-button>
          <b-button
            size="sm"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('participations.reject')"
            @click="showRejectParticipationFn(data.item)"
          >
            <template>
              <b-icon icon="hand-thumbs-down"></b-icon>
            </template>
          </b-button>
          </template>
        </template>
        <b-button
            size="sm"
            variant="transparent"
            v-b-tooltip.hover
            :title="$t('participations.cancel')"
            @click="showCancelParticipationFn(data.item)"
            v-if="['AWAITING_PAYMENT', 'PENDING'].includes(data.item.status)"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import { prettifyDate } from "../../services/utils";

export default {
  props: {
    participations: Array,
    actions: Object
  },
  mounted() {
    this.fields = this.mainFields;
  },
  data() {
    return {
      pageOptions: [10, 20, 50],
      mainFields: [
        { key: "activity.id", label: "Κωδικός Εκπαίδευσης", sortable: true },
        {
          key: "status",
          label: "Κατάσταση",
          sortable: true,
          formatter: "translateStatus",
        },
        // { key: "rejectComments", label: "Σχόλια", sortable: true },
        {
          key: "activity.module",
          label: "Περιγραφή",
          sortable: true,
          filterByFormatted: true,
          formatter: "showTitle",
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "member",
          label: "Συμμετέχων",
          sortable: true,
          filterByFormatted: true,
          formatter: "showName",
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "member.orgUnit.name",
          label: "Κλιμάκιο",
          sortable: true,
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "paymentType",
          label: "Τρόπος Πληρωμής",
          sortable: true,
          formatter: "translatePaymentType",
        },
        { key: "paymentInfo", label: "Πληροφορίες Πληρωμής", sortable: false },
        {
          key: "activity.periods",
          label: "Ημ/νιες Διεξαγωγής",
          sortable: true,
          filterByFormatted: true,
          formatter: "showPeriods",
          tdClass: "maxWidth",
        },
        { key: "action", label: "Ενέργεια", sortable: false, tdClass: "actionClass" },
      ],
      fields: null,
      dataForForm: { show: false },
    };
  },
  methods: {
    prettifyDate(date) {
      return prettifyDate(date);
    },
    showTitle(mod) {
      return mod.title;
    },
    translatePaymentType(type) {
      return this.$t(`paymentTypeEnums.${type}`);
    },
    translateStatus(type) {
      return this.$t(`participationStatusEnums.${type}`);
    },
    showName(member) {
      return member.firstName + " " + member.surName;
    },
    showPeriods(periods) {
      let periodText = "";
      if (periods.length > 0) {
        for (let i = 0; i < periods.length; i++) {
          const period = periods[i];
          let startDate = new Date(period.startDate);
          let endDate = new Date(period.endDate);
          periodText += `${startDate.toLocaleString()}   - ${endDate.toLocaleString()} (${
            period.location
          })`;
          if (periods.length > 1 && i < periods.length - 1) {
            periodText += ` , `;
          }
        }
      } else {
        periodText = "-";
      }
      return periodText;
    },
    showApproveParticipationFn(participation) {
      this.dataForForm = {
        participation: participation,
        action: "approve",
        show: true,
      };
      this.$emit("show-form", this.dataForForm);
    },
    showCancelParticipationFn(participation) {
      this.dataForForm = {
        participation: participation,
        action: "cancel",
        show: true,
      };
      this.$emit("show-form", this.dataForForm);
    },
    showRejectParticipationFn(participation) {
      this.dataForForm = {
        participation: participation,
        action: "reject",
        show: true,
      };
      this.$emit("show-form", this.dataForForm);
    },
    rowClass(item) {
      return { style: `background-color: ${item?.activity.module.color};` };
    },
  },
};
</script>

<style>
.maxWidth {
  max-width: 400px;
}

.actionClass {
  width: 6rem;
  min-width: 6rem;
}
</style>
